/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_No_ModelsInputs */



/**
* | output |
* | --- |
* | "The endpoint lists no chat models." |
*
* @param {Private_Models_Hint_No_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_no_models = /** @type {((inputs?: Private_Models_Hint_No_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_No_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Endpunkt listet keine Chat-Modelle.")
	return /** @type {LocalizedString} */ ("The endpoint lists no chat models.")
});